window.addEventListener('DOMContentLoaded', () => {
  const lazyElements = document.querySelectorAll('[data-lazy], .lazyload, .shopify-section--lazy');

  lazyElements.forEach(el => {
    el.classList.remove('lazyload');
    el.removeAttribute('data-lazy');
    el.style.opacity = 1;
  });
});
